<template>
  <v-card width="375" flat class="account-selection mx-auto">
    <BackButton v-if="!singlePaymentMethod" @click="$emit('abort')"/>

    <div class="card-item-container">
      <div class="pageTitle">{{$t('automatic_debit')}}</div>
      <div class="pageSubtitle2 mt-7 mb-1">{{$t('select_account')}}</div>
      <v-list flat class="pb-0 mb-5">
          <v-list-item v-for="(alias, index) in cards.aliasList" :key="alias.aliadId"
            class="cardItem"
            :class="{selected: index === selectedAliasIndex}"
            :disabled="isDeleted(alias)"
            @click="selectedAliasIndex = index">
            <v-list-item-content>
              <div v-if="alias.aliasLabel" class="card-alias-label ml-2">{{ alias.aliasLabel }} </div>
              <div v-if="!isDeleted(alias)" class="d-flex align-center">
                <div class="ml-2 card-number">{{ alias.cardMaskedPan }} </div>
                
                <v-spacer/>
                <check-icon class='check' v-if="index === selectedAliasIndex"/>
                <cross-icon class='cross'
                  @click.stop="promptSuppressCard(alias)"/>
              </div> 
              <div v-else class="d-flex align-center">
                <div class="ml-2 deleted-card">{{ $t('deleted_account') }} </div>
              </div>           
            </v-list-item-content>
          </v-list-item>
      </v-list>

      <div class="pageSubtitle button ml-2"
        @click.stop="submit(true)">
        {{$t('use_other_account')}}
      </div>

    </div>

    <v-card-actions class="mt-10 pa-0">
      <ConfirmButton
        @click="submit"
        class="icon-button mb-8"
        :disabled="!(this.selectedAliasIndex >= 0)">
          <div>{{$t('pay')}}</div>
          <img class="button-icon" src="@/assets/lock-closed-outline.svg"/>
      </ConfirmButton>
      
    </v-card-actions>

    <v-dialog
      v-model="showDeleteCardPrompt"
      persistent
    >      
      <v-card class="delete-card-prompt">
        <div class="delete-title">{{$t('delete_account')}}</div>
        <div v-if="cardToDelete.aliasLabel" class="card-alias-label mb-n2">{{cardToDelete.aliasLabel}}</div>
        <div class="delete-card-number">{{cardToDelete.cardMaskedPan}}</div>
        <ConfirmButton
          @click="suppressCard(cardToDelete)">
          {{$t('confirm')}}
        </ConfirmButton>
        <div @click="showDeleteCardPrompt = false" class="abort-button">{{$t('abort')}}</div>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
  import { VCard, VCardActions, VSpacer, VList, VListItem, VListItemContent, VDialog } from 'vuetify/lib'
  import ConfirmButton from '@/components/ConfirmButton'
  import BackButton from '@/components/BackButton'
  import RequestHandler from '../../../mixins'
  import CheckIcon from 'vue-material-design-icons/Check.vue'
  import CrossIcon from 'vue-material-design-icons/Close.vue'
  import {mapState} from 'vuex'

  export default {
    name: 'AccountSelectionSDD',
    props: ['cards'],
    components: { 
      VCard,
      VCardActions,
      VSpacer,
      BackButton, 
      ConfirmButton,
      VList,
      VListItem,
      VListItemContent,
      VDialog,
      CheckIcon,
      CrossIcon
    },
    mixins: [RequestHandler],
    computed: {
      ...mapState(['singlePaymentMethod']),
      selectedAlias: function () {
        return this.cards.aliasList ? this.cards.aliasList[this.selectedAliasIndex] : null
      },
      // hasAliases: function () {
      //   return this.cards.aliasList && this.cards.aliasList.length
      // }
    },
    methods: {
      submit: function (enterNewAccount) {
        if (enterNewAccount) this.$emit('select', { item: this.cards, aliasId: null })
        else if (this.selectedAlias) this.$emit('select', { item: this.cards, aliasId: this.selectedAlias.aliasId })        
      },
      promptSuppressCard: function (card) {
        this.cardToDelete = card
        this.showDeleteCardPrompt = true
      },
      suppressCard: function (card) {
        this.showDeleteCardPrompt = false
        this.callSuppressAlias(card.aliasId)
        .then(rep => {
          if (!rep) throw new Error(this.$t('error_treatment'))
          const content = rep.content
          if (content && content.statusCode === '0') {
            this.deletedCards.push(card.aliasId)
            if (this.selectedAlias === card) this.selectedAliasIndex = -1
          }
          else if (process.env.NODE_ENV !== 'production') {
            if (this.selectedAlias === card) this.selectedAliasIndex = -1
            this.deletedCards.push(card.aliasId)
          }
        })
      },
      isDeleted: function (card) {
        return this.deletedCards.indexOf(card.aliasId) !== -1
      }
    },
    data: function () {
      return {
        selectedAliasIndex: 0,
        deletedCards: [],
        cardToDelete: {},
        showDeleteCardPrompt: false,
        // termsOfServiceChecked: false
      }
    }
  }
</script>